import React from 'react';
import RentalCta from '~/components/molecules/RentalCta';
import { rentalCtaLabels } from '~/data/translations/rentalCtaLabels';

export default function FooterRentalCta({ showHelpFeatures, pageLanguage }) {
  const labels = rentalCtaLabels[pageLanguage] || rentalCtaLabels.en;

  return (
    <div className="mb-10">
      <RentalCta
        isHero
        sideBySide
        showReviewsBanner={false}
        editablePostcode
        subheading={labels.subheading}
        heading={labels.heading}
        headingBoldFrom={labels.headingBoldFrom}
        subheadingClassName="text-blue"
        showHelpFeatures={showHelpFeatures}
        language={pageLanguage}
      />
    </div>
  )
}
